import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Battery6BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_6_bar"}/>
}
